import ReactEmoji from "react-emoji-render"
import React from "react"

interface EmojiProps {
  className?: string
  text: string
}

export const Emoji: React.FC<EmojiProps> = ({ className, text }) => {
  return <ReactEmoji className={className} text={text} />
}
